import axiosService from "@/modules/axios-service";

class StatementsService {
  documentsPath = "/statement-reader/documents";
  uploadPath = "/statement-reader/upload";

  async fetchDocuments(skip = 0, take = 25) {
    return await axiosService.get(this.documentsPath, {
      params: {
        skip: skip,
        take: take,
      },
    });
  }

  async fetchDownloadUrl(documentId) {
    return await axiosService.get(
      `${this.documentsPath}/${encodeURIComponent(documentId)}/download`
    );
  }

  async uploadPdf(files) {
    const normalizedFiles = (Array.isArray(files) ? files : [files]).map(
      ({ fileName, pdfBase64 }) => ({ fileName, pdfBase64 })
    );

    const results = await Promise.allSettled(
      normalizedFiles.map((file) => axiosService.post(this.uploadPath, file))
    );
    const failedUpload = results.find((result) => result.status === "rejected");
    if (failedUpload) {
      throw failedUpload.reason;
    }

    return results.length === 1
      ? results[0].value
      : results.map((result) => result.value);
  }
}

export default new StatementsService();
